import { RouteConfig, RouteRecord } from 'vue-router';
import {
  DEVICE, SCREEN_TYPE, Screen,
} from '@/define/Adapter';
import { getMatchDevice } from './device';
import { getMatchScreen } from './screen';

const getXRouteName = (routeName: string, X: string) => `${routeName}.${X}`;

const getMinRouteName = (routeName: string) => getXRouteName(routeName, 'Min');
const getMaxRouteName = (routeName: string) => getXRouteName(routeName, 'Max');

const getMobileRouteName = (routeName: string) => getXRouteName(routeName, 'Mobile');
const getPCRouteName = (routeName: string) => getXRouteName(routeName, 'PC');
const getTVRouteName = (routeName: string) => getXRouteName(routeName, 'TV');

interface RouteAdapterRule {
  device?: DEVICE[];
  screens?: Screen[];
}

export const getAdapterRedirectName = (
  routeAdapterRules: RouteAdapterRule[], routeName: string,
) => {
  let targetRouteName = routeName;

  const matchDevice = getMatchDevice();

  if (!matchDevice) {
    console.warn('无法识别当前设备');
  } else {
    const deviceMatchedRule = routeAdapterRules
      .find((routeAdapterRule) => routeAdapterRule.device?.includes(matchDevice));
    if (deviceMatchedRule) {
      switch (matchDevice) {
        case DEVICE.Mobile:
          targetRouteName = getMobileRouteName(targetRouteName);
          break;
        case DEVICE.PC:
          targetRouteName = getPCRouteName(targetRouteName);
          break;
        case DEVICE.TV:
          targetRouteName = getTVRouteName(targetRouteName);
          break;
        default:
      }
    }

    let screens = deviceMatchedRule?.screens;
    if (!screens) {
      screens = routeAdapterRules
        .find((routeAdapterRule) => !routeAdapterRule.device && routeAdapterRule.screens)?.screens;
    }
    if (screens) {
      const matchScreen = getMatchScreen(screens);
      if (matchScreen) {
        switch (matchScreen.type) {
          case SCREEN_TYPE.MAX:
            targetRouteName = getMaxRouteName(targetRouteName);
            break;
          case SCREEN_TYPE.MIN:
            targetRouteName = getMinRouteName(targetRouteName);
            break;
          default:
        }
      }
    }
  }

  return targetRouteName;
};

export const getIsValidRouteName = (routes: RouteConfig[], routeName: string) => {
  const isValidRouteName = routes.some((route) => {
    if (route.name === routeName) {
      return true;
    }
    if (route.children) {
      return getIsValidRouteName(route.children, routeName);
    }
    return false;
  });
  return isValidRouteName;
};

export const getAdapterRedirectRoute = (
  to: RouteRecord,
  routes: RouteConfig[],
  params: { [key: string]: string },
  query: { [key: string]: string | (string | null)[] },
) => {
  const adapterRules = to.meta?.adapterRules as (null | RouteAdapterRule[]);
  let ret = null;
  if (adapterRules) {
    if (typeof to.name !== 'string') {
      console.warn('当前adapter配置无效，因为目标路由name字段类型必须为string');
    } else {
      const redirectRouteName = getAdapterRedirectName(adapterRules, to.name);
      const isValidRouteName = getIsValidRouteName(routes, redirectRouteName);
      if (isValidRouteName) {
        const nextParams = { ...params, isRedirect: 'true' };
        ret = {
          name: redirectRouteName,
          params: nextParams,
          query,
        };
      } else {
        console.warn(`当前adapter配置无效，因为没有找到对应的路由${redirectRouteName}`);
      }
    }
  }
  return ret;
};

export const setCookie = (cookie: string) => {
  const cookieList = cookie.split(';');
  cookieList.forEach((item) => {
    document.cookie = `${item};maxAge=-1;path=/`;
  });
};
